/**
 * Parses the opening and closing hours of a location and returns them in minutes from midnight.
 * @param {string} hours - The opening and closing hours in the format "HH:MMAM - HH:MMPM".
 * @returns {number[]} An array with two elements: open and close times in minutes from midnight.
 */
export const getOpenClose = (hours) => {
	// Trim each side: the databus supplies hours in the spaced
	// "9:00AM - 5:00PM" form, and the parts are interpolated straight into
	// user-facing text (e.g. "Closes 5:00PM").
	return hours.split('-').map((time) => time.trim().toUpperCase());
};
